import { render, staticRenderFns } from "./reflowBox.vue?vue&type=template&id=435c19ad&scoped=true"
import script from "./reflowBox.vue?vue&type=script&lang=js"
export * from "./reflowBox.vue?vue&type=script&lang=js"
import style0 from "./reflowBox.vue?vue&type=style&index=0&id=435c19ad&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435c19ad",
  null
  
)

export default component.exports